import React from "react";
import { Link } from "react-router-dom";

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({
  totalPages,
  currentPage,
  onPageChange,
}: PaginationProps) => {
  const getPageNumbers = () => {
    const pageNumbers: (number | string)[] = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage > 3) {
        pageNumbers.push(1, "...");
      }

      const startPage = Math.max(1, currentPage - 1);
      const endPage = Math.min(totalPages, currentPage + 1);

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      if (currentPage < totalPages - 2) {
        pageNumbers.push("...", totalPages);
      }
    }

    return pageNumbers;
  };

  return (
    <div className="blog-pagination">
      <nav>
        <ul className="pagination page-item justify-content-center">
          {/* Previous Button */}
          <li className={`previtem ${currentPage === 1 ? "disabled" : ""}`}>
            <Link
              className="page-link"
              to="#"
              onClick={() => onPageChange(currentPage - 1)}
            >
              <i className="fas fa-regular fa-arrow-left" />  
            </Link>
          </li>

          {/* Page Numbers */}
          <li className="justify-content-center pagination-center">
            <div className="page-group">
              <ul>
                {getPageNumbers().map((page, index) => (
                  <li key={index} className="page-item">
                    {typeof page === "number" ? (
                      <Link
                        className={`page-link ${currentPage === page ? "active" : ""}`}
                        to="#"
                        onClick={() => onPageChange(page)}
                      >
                        {page}
                      </Link>
                    ) : (
                      <a className="page-link disabled">{page}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </li>

          {/* Next Button */}
          <li
            className={`nextlink ${currentPage === totalPages ? "disabled" : ""}`}
          >
            <Link
              className="page-link"
              to="#"
              onClick={() => onPageChange(currentPage + 1)}
            >
                <i className="fas fa-arrow-right" />
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
